"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableListCard = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const edd_1 = require("@/domains/edd");
const VariableListCard = ({ variables }) => {
    const [openFormCard, setOpenFormCard] = (0, react_1.useState)(null);
    const [successBannerMsg, setSuccessBannerMsg] = (0, react_1.useState)(null);
    const [errorBannerMsg, setErrorBannerMsg] = (0, react_1.useState)(null);
    const handleDeleteForm = (message) => {
        if (message.type === 'success') {
            setSuccessBannerMsg(message.content);
            setErrorBannerMsg(null);
            return;
        }
        setSuccessBannerMsg(null);
        setErrorBannerMsg(message.content);
    };
    const handleFormBannerDismiss = () => {
        setErrorBannerMsg(null);
        setSuccessBannerMsg(null);
    };
    const handleOpenFormCard = (name) => {
        setOpenFormCard((current) => (current === name ? null : name));
        handleFormBannerDismiss();
    };
    const handleNewFormCard = () => {
        setOpenFormCard((current) => (current === 'new' ? null : 'new'));
        handleFormBannerDismiss();
    };
    const handleFormSuccess = (message) => {
        setSuccessBannerMsg(message);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.BlockStack, { gap: '200', id: 'edd-variable-list-card' },
                react_1.default.createElement(polaris_1.Text, { as: 'h3', id: 'edd-delivery-date-ranges-card-title', variant: 'headingSm' }, "Estimated Delivery Date Ranges"),
                react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' },
                    "The Estimated Delivery Date Ranges show the time in transit between order picked up by the carrier to delivered. Not sure what to set your range at? Check your average 'Carrier picked up to delivered' time on the\u00A0",
                    react_1.default.createElement(polaris_1.Link, { removeUnderline: true, target: '_blank', url: '/reports/shipping_performance' }, "shipping performance\u00A0"),
                    "report."),
                renderMessageBanner(),
                react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '400' },
                    react_1.default.createElement(polaris_1.BlockStack, { gap: '300', id: 'edd-variable-and-new-cards' },
                        renderVariablesList(),
                        react_1.default.createElement(edd_1.EDDVariableForm, { mode: 'new', onFormCardToggle: handleNewFormCard, onFormSuccess: handleFormSuccess, show: openFormCard === 'new' })))))));
    function renderMessageBanner() {
        const tone = successBannerMsg ? 'success' : 'critical';
        if (successBannerMsg || errorBannerMsg) {
            return (react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '400' },
                react_1.default.createElement(polaris_1.Banner, { onDismiss: handleFormBannerDismiss, tone: tone }, tone === 'success' ? successBannerMsg : errorBannerMsg)));
        }
        return undefined;
    }
    function renderVariablesList() {
        return (react_1.default.createElement(react_1.default.Fragment, null, filterSpecialVars(variables).map((variable) => (react_1.default.createElement(edd_1.EDDVariableForm, { key: variable.name, onFormCardToggle: () => handleOpenFormCard(variable.name), onFormDelete: (message) => handleDeleteForm(message), onFormSuccess: (message) => handleFormSuccess(message), show: openFormCard === variable.name, variable: variable })))));
    }
    function filterSpecialVars(vars) {
        const specialVarNames = ['cutoff_time'];
        return vars.filter((variable) => !specialVarNames.includes(variable.name));
    }
};
exports.VariableListCard = VariableListCard;
